import React from "react";

import { FormDescription } from "2g-form";
import Widget, { Theme } from "2g-widget";
import { Icons } from "2g-icons";

import ProvozniInformaceSearch from "b2b/components/provozni-informace-search";
import ProvozniInformaceCards from "b2b/components/provozni-informace-cards";
import Authorized from "b2b/components/auth";

import useProvozniInformaceWidget from "./useProvozniInformaceWidget";
import useMessages from "./i18n/useMessages";

function ProvozniInformaceWidget() {
  const messages = useMessages();
  const { filter, items, loading, reload, redirectToVytvoreni } =
    useProvozniInformaceWidget();

  return (
    <Widget
      className="b2b-ProvozniInformace"
      collapsable={false}
      title={messages.pageHeading()}
      headerActions={[
        <Authorized
          key="action-Add"
          roles={["admin", "vuz_spravce", "vuz_edit"]}
        >
          <Theme.HeaderAction onClick={redirectToVytvoreni}>
            <Icons.Plus />
            <span>{messages.pageHeadingAdd()}</span>
          </Theme.HeaderAction>
        </Authorized>,
        <Theme.HeaderAction key="action-filter" onClick={filter.slide.onOpen}>
          <Icons.Filter />
          <span>{messages.pageHeadingFilter()}</span>
        </Theme.HeaderAction>
      ]}
    >
      <FormDescription
        moduleKey={filter.form.moduleKeyHidden}
        onClick={filter.slide.onOpen}
      />
      <ProvozniInformaceSearch {...filter} />
      <ProvozniInformaceCards
        items={items}
        loading={loading}
        onDeleteSuccess={reload}
        editable
        deletable
      />
    </Widget>
  );
}

export default React.memo(ProvozniInformaceWidget);
